<template>
  <div>
    <div v-if="loading" class="loading-overlay">
      <b-spinner
        label="Loading..."
        variant="primary"
        class="spinner"
      ></b-spinner>
    </div>
    <div v-else class="lender-dashboard">
      <div class="d-flex justify-content-center" style="">
        <div style="width: 85%">
          <div class="d-flex">
            <div class="flex-grow-1 mb-5" style="overflow: hidden">
              <b
                style="
                  font-size: 80px;
                  color: #404040;
                  display: block;
                  margin-top: -26px;
                "
                class="text-truncate"
                >{{ activeLender?.name }}</b
              >

              <div class="d-flex" style="margin-left: 8px; gap: 20px">
                <div style="font-size: 25px">
                  {{ schoolList.length }}
                  {{ schoolList.length > 1 ? "Schools" : "School" }}
                </div>

                <img
                  style="
                    width: 1px;
                    position: relative;
                    overflow: hidden;
                    max-width: 100%;
                    flex-shrink: 0;
                  "
                  src="/static/img/separator.svg"
                />

                <div style="font-size: 25px">
                  {{ activeLender?.lenderToStudentMaps.length }}
                  Students
                </div>
              </div>
              <div
                class="d-flex"
                style="margin-left: 8px; gap: 20px; width: 50%"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center">
        <div style="width: 85%">
          <div style="width: 100%" class="d-flex justify-content-between">
            <b style="font-size: 25px">School List</b>
            <div style="color: #40404080; gap: 15px" class="d-flex">
              <span v-if="schoolList.length > 6" style="cursor: pointer"
                >See all
                <img
                  style="transform: rotate(-90deg)"
                  src="/static/img/chevron-down.svg"
              /></span>
            </div>
          </div>
          <div
            style="
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 30px;
            "
          >
            <div
              v-for="school in schoolList.slice(0, 6)"
              :key="school.id"
              class="boxcontainer"
            >
              <div class="d-flex">
                <div class="" style="overflow: hidden; width: 100%">
                  <b
                    class="text-truncate"
                    style="
                      display: block;
                      font-size: 40px;
                      cursor: pointer;
                      width: 100%;
                    "
                    @click="
                      $router.push(
                        `/hilo/lender/applications?school=${school.name}`,
                      )
                    "
                    >{{ school.name }}</b
                  >
                  <div
                    style="font-size: 15px; color: #404040; width: 100%"
                    class="d-flex justify-content-between"
                  >
                    <span
                      class="text-truncate justify-content-center"
                      style="width: 45%"
                      >{{ school?.count }} Active Students</span
                    >
                  </div>
                </div>
                <div
                  class="flex-grow-1 align-items-right d-flex justify-content-end"
                ></div>
              </div>
              <div :style="divStyle">
                <b>Average Grade: {{ averageGrade }}%</b>
              </div>
            </div>
          </div>

          <div
            style="margin-top: 25px; margin-bottom: 25px; width: 100%"
            class="d-flex justify-content-between"
          >
            <b style="font-size: 25px">Needs Attention</b>
          </div>
          <div
            style="
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 30px;
            "
          >
            <div
              v-for="(student, index) in furthestBehindStudents"
              :key="index"
              class="boxcontainer"
            >
              <div
                class="d-flex justify-content-between"
                style="font-size: 40px"
              >
                <b
                  class="text-truncate"
                  style="display: block; max-width: 70%"
                  >{{ student.name }}</b
                >
                <div
                  class="d-flex justify-content-between"
                  style="min-width: 20%"
                >
                  <b style="color: red">{{ student.daysMargin }}</b>
                </div>
              </div>
              <div class="d-flex justify-content-between">
                <span style="font-size: 25px">{{ student.program }}</span>
                <div
                  class="tag"
                  :style="{
                    'background-color': getTrackingColor(student.tracking),
                  }"
                >
                  {{ checkDaysMargin(student.daysMargin) }}
                </div>
              </div>
              <div class="d-flex" style="width: 100%">
                <span>{{ student.school }}</span>
              </div>
              <div class="d-flex" style="gap: 10px">
                <div>
                  Start: {{ new Date(student.start).toLocaleDateString() }}
                </div>
                <span>|</span>
                <div>End: {{ new Date(student.end).toLocaleDateString() }}</div>
              </div>
              <div
                style="
                  margin-top: 10px;
                  display: grid;
                  grid-template-columns: 3fr 3fr 3fr 1fr;
                "
              >
                <div
                  class="d-flex flex-column align-items-center"
                  style="gap: 5px"
                >
                  <div class="tag blue text-truncate">
                    ${{ student.balance }}
                  </div>
                  <span style="font-size: 11px; color: #40404080">Balance</span>
                </div>
                <!-- <div
                class="d-flex flex-column align-items-center"
                style="gap: 5px"
              >
                <div class="tag blue text-truncate">{{ student.funded }}</div>
                <span style="font-size: 11px; color: #40404080"
                  >Total Funded</span
                >
              </div> -->
                <div
                  class="d-flex flex-column align-items-center"
                  style="gap: 5px"
                >
                  <div
                    style="
                      min-width: 25px;
                      max-width: 25px;
                      width: 25px;
                      height: 25px;
                      cursor: pointer;
                      background-color: #b5b5b5;
                      border-radius: 5px;
                    "
                    class="d-flex justify-content-center align-items-center"
                    @click="goToProfile(student.link)"
                  >
                    <img src="/static/img/LinkIcon.svg" />
                  </div>
                  <span style="font-size: 11px; color: #b5b5b5">Profile</span>
                </div>
              </div>
              <div
                style="
                  margin-top: 10px;
                  display: grid;
                  grid-template-columns: 1fr 1fr 1fr;
                  gap: 10px;
                "
              >
                <div
                  class="tag gray text-center"
                  style="cursor: pointer"
                  @click="goToGradebook(student.gradeBook)"
                >
                  Grade Book
                </div>
                <div
                  class="tag gray text-center"
                  style="cursor: pointer"
                  @click="goToLogbook(student.logBook)"
                >
                  Log Book
                </div>
                <div :style="blockStyle">Grade: {{ student.grade }}%</div>
              </div>
            </div>
          </div>
          <AllStudents
            style="margin-top: 30px; width: 100%"
            class="d-flex align-items-center justify-content-center"
          ></AllStudents>
        </div>
      </div>

      <Modal title="Add School" v-model="isAddingNewSchool">
        <div style="width: 100%">
          <div class="row">
            <div :class="['formLabel', 'col-3']">School Name</div>
            <div class="col-9">
              <input
                v-model="schoolForm.name"
                class="name"
                placeholder="School Name..."
              />
            </div>
          </div>
          <div class="row" style="margin-top: 15px">
            <div :class="['formLabel', 'col-3']">Email</div>
            <div class="col-9">
              <input
                v-model="schoolForm.email"
                class="name"
                placeholder="Email..."
              />
            </div>
          </div>
          <div class="row" style="margin-top: 15px">
            <div :class="['formLabel', 'col-3']">Phone Number</div>
            <div class="col-9">
              <input
                v-model="schoolForm.phoneNumber"
                class="name"
                placeholder="Phone Number..."
              />
            </div>
          </div>
        </div>
        <template #footer>
          <button style="width: 100%" @click="isAddingNewSchool = false">
            Send Request
          </button>
        </template>
      </Modal>

      <Modal title="Documents" v-model="isViewingDocuments">
        <div class="row" style="width: 100%">
          <div class="col-9">Hil Contract</div>
          <div class="col-3 d-flex" style="gap: 10px">
            <button>View</button>
            <button>Edit</button>
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-9">Required Flight School Contract Elements</div>
          <div class="col-3 d-flex" style="gap: 10px">
            <button>View</button>
            <button>Edit</button>
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-9">Required Student Contract Elements</div>
          <div class="col-3 d-flex" style="gap: 10px">
            <button>View</button>
            <button>Edit</button>
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-9">TSA Certification</div>
          <div class="col-3 d-flex" style="gap: 10px">
            <button>View</button>
            <button>Edit</button>
          </div>
        </div>

        <template #footer>
          <div class="d-flex" style="gap: 10px; width: 100%">
            <button
              style="background-color: #40404040; color: #404040"
              class="flex-grow-1"
              @click="isViewingDocuments = false"
            >
              Add Document
            </button>
            <button class="flex-grow-1" @click="isViewingDocuments = false">
              Close
            </button>
          </div>
        </template>
      </Modal>

      <Modal title="Notes" v-model="isViewingNotes">
        <div style="width: 100%">
          <div>
            <div>
              <div><b>Students Didn't Show Up</b></div>
              <div>
                <span style="color: #40404050; font-size: 14px">Feb 21</span>
              </div>
              <div>Students missed critical dead lines</div>
            </div>
            <hr />
          </div>
          <div>
            <div>
              <div><b>Students Didn't Show Up</b></div>
              <div>
                <span style="color: #40404050; font-size: 14px">Feb 21</span>
              </div>
              <div>Students missed critical dead lines</div>
            </div>
            <hr />
          </div>
        </div>
        <div style="width: 100%">
          <div class="row">
            <div :class="['formLabel', 'col-3']">Subject</div>
            <div class="col-9">
              <input
                v-model="noteForm.subject"
                class="name"
                placeholder="Subject..."
              />
            </div>
          </div>
          <div class="row" style="margin-top: 15px">
            <div :class="['formLabel', 'col-3']">Cc</div>
            <div class="col-9">
              <hilo-select
                ref="notes"
                v-model="noteForm.cc"
                :searchable="true"
                :options="people"
                :placeholder="'Select all that apply'"
                :theme="'grey'"
              />
            </div>
          </div>
          <div class="row" style="margin-top: 15px">
            <div :class="['formLabel', 'col-3']">Note</div>
            <div class="col-9">
              <input
                v-model="noteForm.note"
                class="name"
                placeholder="Write note..."
              />
            </div>
          </div>
        </div>
        <template #footer>
          <button @click="isViewingNotes = false" style="width: 100%">
            Save
          </button>
        </template>
      </Modal>
    </div>
  </div>
</template>

<script>
import {
  getGradeColor,
  getTrackingColor,
} from "@/util/gradesAndTrackingColors";
import AllStudents from "./Lender/tabs/AllStudents.vue";
import LendersAPIService from "../../../servicehandlers/LenderAPIService";
import ActiveStudentsAPIService from "../../../servicehandlers/ActiveStudentsAPIService";
import Modal from "../Components/Modal.vue";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import { getProcessedImageUrl } from "@/util/images";
const lendersAPIService = new LendersAPIService();
const activeStudentsAPIService = new ActiveStudentsAPIService();

export default {
  components: {
    HiloSelect,
    Modal,
    AllStudents,
  },
  data() {
    return {
      loading: true,
      noteForm: {
        subject: null,
        cc: null,
        note: null,
      },
      people: [],
      isAddingNewSchool: false,
      isViewingDocuments: false,
      isViewingNotes: false,
      sortBy: null,
      sortOrder: "asc",
      isHovered: false,
      students: [],
      columns: [
        {
          key: "profile",
          label: "Profile",
          component: "HiloButton",
          componentProps: () => ({
            styleType: "profileIcon",
          }),
        },
        { key: "name", label: "Name" },
        { key: "dateFunded", label: "Date Funded" },
        { key: "startDate", label: "Start Date" },
        { key: "endDate", label: "End Date" },
        { key: "checkrideDate", label: "Checkride Date" },
        { key: "grade", label: "Grade" },
        { key: "tracking", label: "Tracking" },
        { key: "program", label: "Program" },
        {
          key: "gradeBook",
          label: "Grade Book",
          component: "HiloButton",
          componentProps: () => ({
            label: "View",
          }),
        },
        {
          key: "note",
          label: "Notes",
          component: "HiloButton",
          componentProps: () => ({
            label: "View",
          }),
        },
      ],
      schoolList: [],
      isExpanded: true,
      tasks: [
        {
          task: "Mason Red - 2nd Disbursement",
          assignedBy: "David Lines",
          dateAssigned: new Date().toLocaleDateString(),
          dateComplete: new Date().toLocaleDateString(),
          time: "+ 50 min 0 sec",
          status: "Complete",
        },
        {
          task: "Mason Red - 2nd Disbursement",
          assignedBy: "David Lines",
          dateAssigned: new Date().toLocaleDateString(),
          dateComplete: new Date().toLocaleDateString(),
          time: "+ 50 min 0 sec",
          status: "Complete",
        },
        {
          task: "Mason Red - 2nd Dissdfsfdfsdfsdfbursessment",
          assignedBy: "David Lines",
          dateAssigned: new Date().toLocaleDateString(),
          dateComplete: new Date().toLocaleDateString(),
          time: "+ 50 min 0 sec",
          status: "Complete",
        },
      ],
      activeLender: null,
      schoolForm: {
        name: null,
        email: null,
        phoneNumber: null,
      },
      averageGrade: null,
    };
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getLenders();
      await this.getStudentsandSchools();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  },
  computed: {
    furthestBehindStudents() {
      return [...this.students].sort((a, b) => a.grade - b.grade).slice(0, 3);
    },
    backgroundColorStyle() {
      let grade = this.averageGrade;
      let red = 0;
      let green = 0;
      let blue = 0;

      if (grade >= 75) {
        green = 255;
        blue = 0;
      } else if (grade >= 50) {
        red = 255;
        green = 165;
        blue = 0;
      } else {
        red = 255;
        green = 0;
        blue = 0;
      }

      return `rgb(${red}, ${green}, ${blue})`;
    },
    divStyle() {
      return {
        "background-color": this.backgroundColorStyle,
        color: "#ffffff",
        "text-align": "center",
        "border-radius": "5px",
        "box-sizing": "border-box",
      };
    },
    blockStyle() {
      return {
        "background-color": this.backgroundColorStyle,
        color: "#ffffff",
        "text-align": "center",
        "border-radius": "5px",
        "box-sizing": "border-box",
      };
    },
    sortedStudents() {
      if (!this.sortBy) {
        return this.students;
      }

      const sortedArray = [...this.students];
      sortedArray.sort((a, b) => {
        let aValue = a[this.sortBy];
        let bValue = b[this.sortBy];

        if (aValue === undefined || aValue === null) aValue = "";
        if (bValue === undefined || bValue === null) bValue = "";

        if (typeof aValue === "string") {
          aValue = aValue.toLowerCase();
          bValue = bValue.toLowerCase();
        }

        if (aValue < bValue) return this.sortOrder === "asc" ? -1 : 1;
        if (aValue > bValue) return this.sortOrder === "asc" ? 1 : -1;
        return 0;
      });

      return sortedArray;
    },
  },
  methods: {
    getProcessedImageUrl,
    getTrackingColor,
    getGradeColor,
    sortStudents(option) {
      if (this.sortBy === option) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortBy = option;
        this.sortOrder = "asc";
      }
    },
    async getStudentsandSchools() {
      const lenderId = this.$store.getUser.lenderId;
      await lendersAPIService
        .getLenderGradeBook(lenderId, this.$router)
        .then(async (response) => {
          const studentSchools = response.studentsWithDetails;
          let totalGrades = 0;
          let gradeCount = 0;

          if (studentSchools && studentSchools.length > 0) {
            for (let i = 0; i < studentSchools.length; i++) {
              await activeStudentsAPIService
                .getStudentGradeDetails(studentSchools[i].Grade, this.$router)
                .then((studentResponse) => {
                  const studentGrade = studentResponse.averageGrade;
                  const studentStatus = studentResponse.daysMargin;
                  let addingToStudent = {
                    name: studentSchools[i].Name,
                    school: studentSchools[i].School,
                    daysMargin: studentStatus,
                    program: studentSchools[i].Program,
                    start: new Date(studentSchools[i].Start),
                    end: studentSchools[i].End
                      ? new Date(studentSchools[i].End)
                      : null,
                    balance: studentSchools[i].Balance,
                    funded: studentSchools[i].Funded,
                    link: studentSchools[i].Link,
                    gradeBook: studentSchools[i]["Grade Book"],
                    logBook: studentSchools[i]["Log Book"],
                    grade: studentGrade.toFixed(2),
                    studentImage: studentSchools[i].Image,
                  };
                  this.students.push(addingToStudent);

                  totalGrades += studentGrade;
                  gradeCount++;

                  if (i === studentSchools.length - 1) {
                    this.averageGrade = (totalGrades / gradeCount).toFixed(2);
                  }
                })
                .catch((error) => {});
            }
          }
        })
        .catch((error) => {});
    },
    checkDaysMargin(daysMargin) {
      if (daysMargin > 0) {
        return "Days Ahead";
      } else if (daysMargin === 0) {
        return "On Time";
      } else {
        return "Days Behind";
      }
    },
    calculateProgressPercentage(progress) {
      const total = 75;
      const percentage = Math.round((progress / total) * 100);
      return percentage > 100 ? 100 : percentage;
    },
    getAverageGrade(studentNames) {
      const grades = studentNames
        .map(
          (name) =>
            this.students.find((student) => student.name === name)?.grade,
        )
        .filter(Boolean);

      const gradeValues = grades.map((grade) => {
        switch (grade) {
          case "A":
            return 4;
          case "B":
            return 3;
          case "C":
            return 2;
          case "D":
            return 1;
          case "F":
            return 0;
          default:
            return 0;
        }
      });

      const average =
        gradeValues.reduce((sum, val) => sum + val, 0) / gradeValues.length;

      if (average >= 3.5) return "A";
      if (average >= 2.5) return "B";
      if (average >= 1.5) return "C";
      if (average >= 0.5) return "D";
      return "F";
    },

    async getLenders() {
      const lenderId = this.$store.getUser.lenderId;

      await lendersAPIService
        .getLendersById(lenderId, this.$router)
        .then(async (lender) => {
          this.activeLender = lender;

          await lendersAPIService
            .getLenderWithTotalAmountLent(lenderId, this.$router)
            .then((totalLent) => {
              this.activeLender.totalLent = totalLent.reduce(
                (acc, curr) => acc + curr,
                0,
              );
            });

          await lendersAPIService
            .getLenderSchoolsById(lenderId, this.$router)
            .then((schools) => {
              this.schoolList = this.$global.groupArrayByKeys(
                schools.flightSchools,
                ["id"],
                true,
              );
            });
        });
    },
    goToProfile(id) {
      this.$router.push({
        name: "Profile Student",
        params: {
          id,
        },
      });
    },
    goToGradebook(studentId) {
      this.$router.push({
        name: "Single Student GradeBook",
        query: {
          studentId,
        },
      });
    },
    goToLogbook(userId) {
      this.$router.push({
        name: "Logbook",
        query: {
          userId,
        },
      });
    },
  },
};
</script>

<style scoped>
.lender-dashboard {
  font-family: Arial, sans-serif;
  color: #333;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.header h1 {
  margin: 0;
}

.logos {
  display: flex;
  justify-content: space-around;
  margin-bottom: 50px;
}

.logo-item {
  margin: 10px;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.logo-container img {
  width: 300px;
  height: auto;
}

.students {
  display: flex;
  justify-content: space-around;
  margin-bottom: 40px;
}

.student-card {
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 20px;
  width: 400px;
  text-align: center;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 0 10px;
}

.student-card h3 {
  margin: 0 0 10px;
  font-size: 18px;
}

.program {
  font-size: 14px;
  color: #555;
}

.dates {
  font-size: 12px;
  color: #888;
  margin: 10px 0;
}

.days-behind {
  background-color: red;
  color: white;
  border-radius: 5px;
  padding: 2px 10px;
  font-weight: bold;
  font-size: 14px;
}

.student-info {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.student-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin: 10px 0;
}

.grade {
  color: white;
  border-radius: 8px;
  width: 60px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
}

.progress-wrapper {
  position: relative;
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress {
  background-color: #babbbb;
  height: 10px;
  border-radius: 5px;
  position: relative;
  width: 80%;
  overflow: hidden;
}

.progress span {
  display: block;
  height: 100%;
  background-color: green;
  transition: width 0.3s ease;
}

.progress-value {
  font-size: 12px;
  font-weight: bold;
  margin-left: 10px;
  color: #333;
}
</style>

<style lang="scss" scoped>
.countiesTask {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 20px;

  th {
    background-color: #194099;
    color: #ffffff;
    text-align: center;
    font-weight: normal;
    font-size: 15px;
    padding: 10px;
  }
  th:first-child {
    border-top-left-radius: 10px;
  }
  th:last-child {
    border-top-right-radius: 10px;
  }
  td {
    text-align: center;
    border: 1px solid rgba(64, 64, 64, 0.5);
    border-style: none solid solid none;
  }
  tr {
    td {
      font-size: 15px;
    }
    td:first-child {
      padding-left: 10px;
      padding-right: 10px;
      max-width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  tr:first-child td {
    border-top-style: solid;
  }
  tr td:first-child {
    border-left-style: solid;
  }
  tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
  }

  tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
  }

  th:nth-child(1),
  td:nth-child(1) {
    width: 15%; /* Adjust the width as needed */
  }
  th:nth-child(2),
  td:nth-child(2) {
    width: 15%; /* Adjust the width as needed */
  }
  th:nth-child(3),
  td:nth-child(3) {
    width: 15%; /* Adjust the width as needed */
  }
  th:nth-child(4),
  td:nth-child(4) {
    width: 15%; /* Adjust the width as needed */
  }
  th:nth-child(5),
  td:nth-child(5) {
    width: 15%; /* Adjust the width as needed */
  }
  th:nth-child(6),
  td:nth-child(6) {
    width: 15%; /* Adjust the width as needed */
  }
  th:nth-child(7),
  td:nth-child(7) {
    width: 10%; /* Adjust the width as needed */
  }
}

.expandable {
  .chevron {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
  }

  &.expanded {
    .chevron {
      transform: rotate(0deg);
    }
  }
}

.accordionBody {
  max-height: 0;
  transition: max-height 0.3s cubic-bezier(0, 1, 0, 1);
  overflow: hidden;

  &.expanded {
    max-height: 1000px;
    transition: max-height 0.3s cubic-bezier(0.4, 0, 1, 1);
  }
}

.boxcontainer {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;
  gap: 10px;
}

.tag {
  color: #ffffff;
  border-radius: 5px;
  padding: 2px 10px;
  font-size: 14px;
  align-self: center;

  &.red {
    background-color: red;
  }

  &.blue {
    background-color: #2c65ea;
  }
  &.gray {
    background-color: #b5b5b5;
  }
}

.rating-bar {
  width: 100%;
  height: 20px;
  background-color: #e2e6e5;
  border-radius: 10px;
  overflow: hidden;

  .rating {
    height: 100%;
    background-color: green;
    width: 50%;
    border-radius: 10px;
    transition: width 0.3s ease;
    text-align: center;
    color: white;
    font-size: 12px;
    line-height: 20px;
  }
}

.studentGrid {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);

  th {
    background-color: #3c97ff;
    color: #ffffff;
    text-align: center;
    font-weight: normal;
    font-size: 15px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  th:first-child {
    border-top-left-radius: 10px;
  }
  th:last-child {
    border-top-right-radius: 10px;
  }

  td {
    text-align: center;
    border: 1px solid rgba(64, 64, 64, 0.5);
    border-style: none solid solid none;
  }
  tr {
    td {
      font-size: 15px;
    }
    td:first-child {
      padding-left: 10px;
      padding-right: 10px;
      max-width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  tr:first-child td {
    border-top-style: solid;
  }
  tr td:first-child {
    border-left-style: solid;
  }

  td:nth-child(2) {
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  td:nth-child(3) {
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.formLabel {
  margin-top: 10px;
  position: relative;
  font-size: 18px;
  font-family: Helvetica, Arial, sans-serif;
  color: #404040;
  text-align: left;
  display: inline-block;
}
</style>
